module.exports = __webpack_public_path__ + "static/media/emj07.828e5b8a.svg";